import type { Attribute, ActionOption } from 'flow/store/engine/types';
import type { ServiceConfigOption } from '~/dashboard/views/settings/service-configuration/types';

/* prunes all archived service attributes */
export function getActiveAttributes(
  attributes: Record<string, Attribute>,
): Record<string, Attribute> {
  return Object.entries(attributes)
    .filter(([, attributeObj]) => !attributeObj.archivedAt)
    .reduce((acc, [attributeId, attributeObj]) => ({
      ...acc, [attributeId]: attributeObj,
    }), {});
}

/* sorts attributes by name into an attribute array */
export function sortAttributes(
  attributes: Record<string, Attribute>,
): Attribute[] {
  return Object.values(attributes)
    .sort((a, b) => (
      (a.display_name ?? '').localeCompare(b.display_name ?? '')
    ));
}

export function convertActionOptionSelectedValueIdsToSlugs(
  option: ActionOption,
  serviceConfigOption: ServiceConfigOption): string[] {
  if (!option.selectedValues
    || !serviceConfigOption.possibleValues
    || option.serviceConfigOptionId
    !== serviceConfigOption.serviceConfigOptionId) {
    return [];
  }
  const serviceConfigIdMap = Object.fromEntries(
    serviceConfigOption.possibleValues.map(
      pv => [pv.serviceConfigPossibleValueId, pv]));
  return option.selectedValues.map(id => serviceConfigIdMap[id].slug);
}
